import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { requestUpdateSize } from 'store/modules/window/actions';

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      updateSize: requestUpdateSize
    },
    dispatch
  );

export interface IWindowDispatchProps {
  updateSize: (payload: { width: number; height: number }) => void;
}

const withWindowActions = connect(
  null,
  mapDispatchToProps
);

export default withWindowActions;



// WEBPACK FOOTER //
// ./src/components/SizeTracker/withWindowActions.tsx